<div class="desktop" *ngIf="!isMobile">
  <div class="row">
    <div class="col">
      <label for="signer-born" class="default-label">{{i18n.SIGNATURE.SUA_ASSINATURA_USE}} <img
          src="../../../assets/icons/DESKTOP/Grupo 209.png" alt=""> {{i18n.SIGNATURE.OU}} <img
          src="../../../assets/icons/DESKTOP/Grupo 208.png" alt=""> )</label>
    </div>
    <div class="col-3 right mt-28px">
      <span class="link" (click)="clearSignature()">{{i18n.SIGNATURE.LIMPAR}}</span>
    </div>
  </div>
  <div class="bordered pt-16px pr-8px pb-16px pl-8px">
    <div class="row align-items-center">
      <div class="col-3">
        <div class="row">
          <div class="col right bordered-right">
            <div class="p-1 link" (click)="writeSignture = false">
              <img src="../../../assets/icons/DESKTOP/desenhar-assinatura.png" ngbTooltip="{{i18n.SIGNATURE.DESENHAR}}" placement="top"
                alt="">
            </div>
          </div>
          <div class="col left bordered-left">
            <div class="p-1 link" (click)="writeSignture = true">
              <img src="../../../assets/icons/DESKTOP/digitar-assinatura.png" ngbTooltip="{{i18n.SIGNATURE.ESCREVER}}" placement="top"
                alt="">
            </div>
          </div>
        </div>
      </div>
      <div class="col" *ngIf="writeSignture">
        <input type="text" class="default-input" placeholder="{{i18n.SIGNATURE.DIGITE_SUA_ASSINATURA}}" (keyup)="transformDivToImgFromScreen()"
          [(ngModel)]="writedSignatureInput">
      </div>
    </div>
    <div class="row" *ngIf="!writeSignture">
      <div class="col center">
        <div class="signature-container">
          <span class="f-opacited mt-32px">
            {{i18n.SIGNATURE.ASSINE_AQUI}}
            <br>
            (
              {{i18n.SIGNATURE.NAO_PRECISA_RG}}
            )
            <br>
            <br>
            {{i18n.SIGNATURE.OU_CLIQUE_EM}} <img src="../../../assets/icons/DESKTOP/digitar-assinatura.png">
            <br>
            {{i18n.SIGNATURE.PARA_DIGITAR_A_ASSINATURA}}.
          </span>
          <signature-pad [options]="signaturePadOptions" (onBeginEvent)="drawStart()" (onEndEvent)="drawComplete()">
          </signature-pad>
          <div class="border-bottom"></div>
        </div>
      </div>
    </div>
    <div class="row pt-32px" *ngIf="writeSignture">
      <div class="col center">
        <div class="row" #screen>
          <div class="col">
            <span [classList]="currentFont.fontName">
              {{writedSignatureInput}}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row border-bottom pt-12px pb-12px center mb-1" *ngIf="writedSignatureInput !== ''">
    <div class="col" id="download">
      <span class="link" (click)="changeFont(currentFont.id)">{{i18n.SIGNATURE.TROCAR_FONTE}}</span>
    </div>
  </div>

</div>
<div class="mobile" *ngIf="isMobile">
  <div class="row align-items-center">
    <div class="col">
      <label for="signer-born" class="default-label f-12">{{i18n.SIGNATURE.SUA_ASSINATURA_USE}} <img
        src="../../../assets/icons/DESKTOP/Grupo 209.png" alt=""> {{i18n.SIGNATURE.OU}} <img
        src="../../../assets/icons/DESKTOP/Grupo 208.png" alt=""> )</label>
    </div>
    <div class="col-3 right mt-14px">
      <span class="link f-12" (click)="clearSignature()">{{i18n.SIGNATURE.LIMPAR}}</span>
    </div>
  </div>
  <div class="bordered pt-16px pr-8px pb-16px pl-8px">
    <div class="row align-items-center">
      <div class="col-3">
        <div class="row">
          <div class="col-7 center bordered-right">
            <div class="p-1 link" (click)="writeSignture = false">
              <img src="../../../assets/icons/DESKTOP/desenhar-assinatura.png" ngbTooltip="{{i18n.SIGNATURE.DESENHAR}}" placement="top"
                class="mobile-icon" alt="">
            </div>
          </div>
          <div class="col-5 left bordered-left">
            <div class="p-1 link" (click)="writeSignture = true">
              <img src="../../../assets/icons/DESKTOP/digitar-assinatura.png" ngbTooltip="{{i18n.SIGNATURE.ESCREVER}}" placement="top"
                class="mobile-icon" alt="">
            </div>
          </div>
        </div>
      </div>
      <div class="col" *ngIf="writeSignture">
        <input type="text" class="default-input" placeholder="{{i18n.SIGNATURE.DIGITE_SUA_ASSINATURA}}" (keyup)="transformDivToImgFromScreen()"
          [(ngModel)]="writedSignatureInput">
      </div>
    </div>
    <div class="row" *ngIf="!writeSignture">
      <div class="col center">
        <div class="signature-container">
          <span class="f-opacited mt-32px">
            {{i18n.SIGNATURE.ASSINE_AQUI}}
            <br>
            (
              {{i18n.SIGNATURE.NAO_PRECISA_RG}}
            )
            <br>
            <br>
            {{i18n.SIGNATURE.OU_CLIQUE_EM}} <img src="../../../assets/icons/DESKTOP/digitar-assinatura.png">
            <br>
            {{i18n.SIGNATURE.PARA_DIGITAR_A_ASSINATURA}}.
          </span>
          <signature-pad [options]="signaturePadOptions" (onBeginEvent)="drawStart()" (onEndEvent)="drawComplete()">
          </signature-pad>
          <div class="border-bottom"></div>
        </div>
      </div>
    </div>
    <div class="row pt-32px" *ngIf="writeSignture">
      <div class="col center">
        <div class="row" #screen>
          <div class="col">
            <span [classList]="currentFont.fontName" style="text-align: center; padding-bottom: 40px; width: 100%;">
              {{writedSignatureInput}}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row border-bottom pt-12px pb-12px center mb-1" *ngIf="writedSignatureInput !== ''">
    <div class="col" id="download">
      <span class="link" (click)="changeFont(currentFont.id)">{{i18n.SIGNATURE.TROCAR_FONTE}}</span>
    </div>
  </div>

</div>

<div id="download" class="hide">
  <img class="no-bg" [src]="signatureBlob" #canvas>
</div>
